require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./workshops-value-proposition-canvas.json") })
        }
      }, "path---workshops-value-proposition-canvas");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---workshops-value-proposition-canvas!./.cache/json/workshops-value-proposition-canvas.json
// module id = 516
// module chunks = 231608221292675